/* eslint-disable */
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import { Grid, Typography, makeStyles, InputLabel, RACSelect, RACTextbox, RACModalCard, RACButton, RACRadio } from "@rentacenter/racstrap";

import { ReactComponent as WarningIcon } from "../assets/images/no-records-found.svg";

import { GetSuggestedAddress, UpdateAddressInfo } from '../api/user';

import { t } from "i18next";
import validateAddressFn from '../refactoredComponents/utils/validateAddressFn';
import { useParams } from 'react-router-dom';
import { ParamType } from '../refactoredComponents/interface/commonInterface';
import { UpdateApiPayload } from '../refactoredComponents/interface/customerInformationInterface';
import CONSTANTS from '../refactoredComponents/constants/constant';
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles((theme) => ({
  bold: {
    fontFamily: 'OpenSans-bold'
  },
  justifyContentCenter: {
    justifyContent: 'center',
  },
  floatRight: {
    float: 'right',
  },
  floatLeft: {
    float: 'left',
  },
  spacerMT2: {
    marginTop: theme.typography.pxToRem(16),
  },
  dispInlineFlex: {
    display: 'inline-flex',
  },
  w100: {
    width: '100%',
  },
  foc: {
    '&:focus': {
      borderColor: '#80bdff',
      boxShadow: '1px 1px 6px 3px #80bdff',
    },
  },
  spacerMT4: {
    marginTop: theme.typography.pxToRem(24),
  },
  spacerMB2: {
    marginBottom: theme.typography.pxToRem(8),
  },
  spacerPX2: {
    paddingLeft: theme.typography.pxToRem(8),
    paddingRight: theme.typography.pxToRem(8),
  },
  RACPOPMsg: {
    fontFamily: 'OpenSans-bold',
    fontSize: theme.typography.pxToRem(16),
    letterSpacing: 0,
  },
  formCheck: {
    minHeight: '1.5rem',
    marginBottom: '0.125rem',
    display: 'inline-block',
    marginRight: '1rem',
    paddingLeft: 0,
  },
  textCenter: {
    textAlign: 'center',
  },
  semiBold: {
    fontFamily: 'OpenSans-semibold',
  },
  saveButton: {
    height: theme.typography.pxToRem(43),
    marginTop: theme.typography.pxToRem(16),
  },

}))
interface AddressComponent {
  componentName: ComponentName,
  componentType: string,
  confirmationLevel: string,
  inferred: boolean,
  spellCorrected: boolean,
  replaced: boolean,
  unexpected: boolean
}
interface ComponentName {
  text: string,
  languageCode: string
}
export interface Address {
  street: string;
  interiorNum?: string;
  exteriorNum: string;
  suburb?: string;
  zipcode: string;
  city: string;
  state: string;
  addressId?: string
};
interface StateOptions {
  label: '',
  value: ''
}
interface MXAddressProps {
  address: Address;
  googleAddressEnabled: boolean;
  setAddress: Dispatch<SetStateAction<Address>>;
  stateOpt: any;
  setActionCompeleted?: Dispatch<SetStateAction<boolean>>
  canEdit: boolean
  processSuggestion?: boolean
  setLoader: (element: boolean) => void;
  setCantProcessAddress?: () => void;
  addressBackup : any;
}
interface PostalAddress {
  addressLines: string[];
  administrativeArea: string;
  postalCode: string;
  locality: string;
}
interface AddressResponse {
  message?: string;
  status: boolean;
  matchCode?: string | undefined;
  suggestedAddress?: string;
  postalAddress?: PostalAddress;
}

export default function MXAddressComp(props: MXAddressProps) {
  /* Props */
  const { address, setAddress, googleAddressEnabled, stateOpt, processSuggestion, canEdit, setLoader, setActionCompeleted, setCantProcessAddress,addressBackup } = props;
    const { t } = useTranslation('Payment');

  /* Styles */
  const classes = useStyles();

  /* Constants */
  const enableInput = {
    street: true,
    interiorNum: true,
    exteriorNum: true,
    suburb: true,
    zipcode: true,
    city: true,
    state: true
  }
  const disableInputField = {
    street: false,
    interiorNum: false,
    exteriorNum: false,
    suburb: false,
    zipcode: false,
    city: false,
    state: false
  }

  /* variables realted to input field */
  const [disableInput, setDisableInput] = useState({
    street: false,
    interiorNum: false,
    exteriorNum: false,
    suburb: false,
    zipcode: false,
    city: false,
    state: false
  });

  /* Popup variables */
  const [cantSuggestAddress, setCantSuggestAddress] = useState<boolean>(false);
  const [canSuggestAddress, setCanSuggestAddress] = useState<boolean>(false);
  const [validatedAddresses, setValidatedAddress] = useState<any>({});
  const [defaultAddress, setDefaultAddress] = useState("GA");
  const [pending, setPending] = useState(false);
  { console.log('The state options passed', stateOpt) }
  const { customerId } = useParams<ParamType>();
  useEffect(() => {
    if (stateOpt && stateOpt.length != 0) {
      loadStates()
    }

  }, [stateOpt]);
  
  
  const loadStates = () => {
    if (stateOpt !== undefined) {
      const stateOps = JSON.parse(JSON.stringify(stateOpt))
      const dropdown = stateOps.map((entry: any) => {
        return {
          label: t(entry.abbreviation),
          value: entry.abbreviation,
        };
      });
      dropdown.unshift({ label: t("Select"), value: "" });
      return dropdown;
    } else {
      return [{ label: t("Select"), value: "" }];
    }
  };

  useEffect(() => {
    if (processSuggestion) {
      getSuggestion();
    }
  }, [processSuggestion])

  const saveAddress = async () => {
    try {
      setPending(true)
      let addressPayload = address
      if (defaultAddress == 'GA') {
        const add = validatedAddresses.postalAddress;
        const state = stateOpt.find((item: any) => item.stateProvinceName.toLowerCase() == add.administrativeArea.toLowerCase());
        const addressObject = {
          street: add.addressLines[0],
          suburb: add.addressLines[1] || address.suburb,
          zipcode: add.postalCode,
          city: add.locality,
          state: (state && state != -1) ? state.abbreviation : add.administrativeArea,
          interiorNum: address.interiorNum,
          exteriorNum: address.exteriorNum,
          addressId: address.addressId
        }
        addressPayload = addressObject
        setAddress(addressObject);
        if (setActionCompeleted)
          setActionCompeleted(true)
      } else {
        if (setActionCompeleted)
          setActionCompeleted(true)
      }

      try {
        const addressObj = {
          "city": addressPayload.city,
          addressType: CONSTANTS.PRIM,
          "postalCode": addressPayload.zipcode,
          "addressLine1": addressPayload.street,
          "addressLine2": addressPayload.suburb,
          "state": addressPayload.state,
          "agreementIds": [],
          "addressId":( addressPayload.addressId as string),
          exteriorNumber: addressPayload.exteriorNum,
          interiorNumber: addressPayload.interiorNum,
          active: CONSTANTS.STATUS_YES
        }
        const payload = {
          customerId: customerId,
          addresses: [addressObj],
        };
        const updateAddrs = await UpdateAddressInfo(payload);
        setCanSuggestAddress(false);
        setPending(false);
        if (updateAddrs.status != 200){
           setCanSuggestAddress(false);
            setPending(false);
        }
        else window.location.reload();
      } catch (error) {
        console.log('Error while updating address', error)
      } finally {
        setCanSuggestAddress(false);
        setPending(false);
      }
    } catch (e: any) {
      console.log('Error while saving data', e)
    }
  }
  const buildAd2 = (ad: any) => {
    return ad !== null && ad !== undefined && ad !== '' && ad.length > 0
      ? ad + ', '
      : '';
  };

  const updateAddress = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, param?: string) => {
    setAddress({ ...address, [param ? param : e.target.id]: e.target.value })
  }
  /* eslint-disable sonarjs/cognitive-complexity */
  const validateZipCode = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const confirmationComp = ['CONFIRMED', 'UNCONFIRMED_BUT_PLAUSIBLE'];
    const zipcode = e.target.value;
    const orderedKeys = ['street', 'exteriorNum', 'interiorNum', 'suburb', 'city', 'state'];
    const addressLines = orderedKeys.map(key => address[key as keyof Address]).filter(value => value !== undefined && value !== null && value !== '');
    addressLines.push(zipcode);
    try {
      if (zipcode.length == 5 && Number(googleAddressEnabled)) {
        setDisableInput({ ...disableInput, 'city': true, 'zipcode': true, 'state': true })
        const payload = {
          MessageID: 'CMS006-93589345',
          MessageType: 'CMS006',
          MessageDTS: '2014-05-23-14:30:15:254633',
          MessageDTSTZOffset: '-06:00',
          RegionID: '1',
          ClientID: '8',
          ClientLocationNumber: '00006',
          ClientSource: '1',
          ClientOriginator: '1',
          LocationNumber: window.sessionStorage.getItem('storeNumber'),
          EncryptionMethod: '0',
          Addresses: [
            {
              AddressID: '11114',
              StreetAddress: address.street,
              City: address.city,
              StateProvince: '',
              PostalCode: address.zipcode,
              Country: 'Mexico',
            },
          ],
          StoreConfig: {
            storeNumbers: [window.sessionStorage.getItem('storeNumber')],
            paramKeyNames: ['AddressDoctorEnabled'],
          },
          enableGoogleAddressValidation: true,
          validateAddress: {
            postalCode: address.zipcode,
            "regionCode": "MX",
            addressLines: addressLines
          }
        };
        const response = await GetSuggestedAddress(payload);
        console.log('The response from google API', response);
        if (response && response.data.validateAddress) {
          const addressComponent = response.data.validateAddress.result.address.addressComponents
          const addressObject = JSON.parse(JSON.stringify(address));
          addressComponent.forEach((element: AddressComponent) => {
            if (element.componentType == 'postal_code' && confirmationComp.includes(element.confirmationLevel)) {
              addressObject.zipcode = element.componentName.text
            }
            if (element.componentType == 'locality' && confirmationComp.includes(element.confirmationLevel)) {
              addressObject.city = element.componentName.text
            }
            if (element.componentType == 'administrative_area_level_1' && confirmationComp.includes(element.confirmationLevel)) {
              const state = stateOpt.find((item) => item.stateProvinceName.toLowerCase() == element.componentName.text.toLowerCase());
              addressObject.state = (state && state != -1) ? state.abbreviation : ''
            }
          });
          setAddress({ ...addressObject })
        }
        setDisableInput({ ...disableInput, 'city': false, 'zipcode': false, 'state': false })
      }
    }
    catch (e: any) {
      console.log('The error while validating zipcode', e)
    }
    finally {
      setDisableInput({ ...disableInput, 'city': false, 'zipcode': false, 'state': false })
    }
  }
  const getSuggestion = async () => {
    try {
      const orderedKeys = ['street', 'exteriorNum', 'interiorNum', 'suburb', 'zipcode', 'city'];
      const addressLines = orderedKeys.map(key => address[key as keyof Address]).filter(value => value !== undefined && value !== null && value !== '');
      const state = stateOpt.find((item) => item.abbreviation.toLowerCase() == address.state.toLowerCase());
      addressLines.push(state.stateProvinceName)
      if (googleAddressEnabled) {
        setDefaultAddress('GA')
        setPending(true);
        const addressPayload: any = {
          MessageID: "CMS006-93589345",
          MessageType: "CMS006",
          MessageDTS: "2014-05-23-14:30:15:254633",
          MessageDTSTZOffset: "-06:00",
          RegionID: "1",
          ClientID: "8",
          ClientLocationNumber: "00006",
          ClientSource: "1",
          ClientOriginator: "1",
          LocationNumber: window.sessionStorage.getItem('storeNumber'),
          EncryptionMethod: "0",
          Addresses: [
            {
              AddressID: "11114",
              StreetAddress: "",
              City: "",
              StateProvince: "",
              PostalCode: "",
              Country: "",
            },
          ],
          StoreConfig: {
            storeNumbers: [window.sessionStorage.getItem('storeNumber')],
            paramKeyNames: ["AddressDoctorEnabled"],
          },
          enableGoogleAddressValidation: true,
          validateAddress: {
            postalCode: address.zipcode,
            "regionCode": "MX",
            addressLines: addressLines
          }
        };

        const response = await GetSuggestedAddress(addressPayload);

        const result: AddressResponse = validateAddressFn(response.data.validateAddress, addressPayload, undefined, true);
        const { status, postalAddress } = result;
        console.log('Postal address from the google API', postalAddress);
        if (status) {
          setCanSuggestAddress(true);
          setValidatedAddress(result);
        }
        else {
          setCantSuggestAddress(true);
          setValidatedAddress(result);
        }

      }
      else {
        /* Build a popup that will show the validation message */
        const message = "Automatic Address validation is Unavailable for the store # Please validate the address Manually."
        console.log('Message', message);
      }
    }
    catch (e) {
      console.log('The error in validation process', { error: e });

    }
    finally {
      setPending(false);
    }
  }
  function suggestErrorInAddress() {
    return (
      <>
        <Grid item md={12}>
          <Grid
            style={{
              justifyContent: "center",
              display: "flex",
              marginBottom: "2%",
            }}
          >
            <WarningIcon width={"10%"} height={"10%"} />
          </Grid>
          <Grid item md={12} className={classes.textCenter}>
            <Typography variant={"body2"} className={classes.RACPOPMsg}>
              {validatedAddresses?.message}
            </Typography>
          </Grid>
          <Grid
            container
            className={`${classes.justifyContentCenter} ${classes.spacerMT4}`}
          >
            <RACButton
              variant="contained"
              color="primary"
              isRounded={false}
              onClick={() => {

                setCantSuggestAddress(false);
                if (setCantProcessAddress)
                  setCantProcessAddress();
              }}
            >
              {t('Ok')}
            </RACButton>
          </Grid>
        </Grid>
      </>
    );
  }

  function suggestAddressFn() {
    return (
      <>
        <Grid item md={12} className={classes.spacerPX2}>
          <Typography className={`${classes.RACPOPMsg} ${classes.bold}`}>
            {t('Entered Address')}
          </Typography>
          <div className={classes.formCheck}>
            <RACRadio
              id="inlineRadio1"
              name="inlineRadioOptions"
              checked={defaultAddress == "ENT" ? true : false}
              onClick={() => setDefaultAddress("ENT")}
              value={"ENT"}
            />
            <Typography
              className={`${classes.RACPOPMsg} ${classes.semiBold} ${classes.dispInlineFlex}`}
            >
              {buildAd2(address?.street)} {buildAd2(address?.exteriorNum)}{buildAd2(address?.interiorNum)} {buildAd2(address?.suburb)}{buildAd2(address?.city)} {address?.state},{address?.zipcode}
            </Typography>
          </div>
          <Grid
            item
            md={12}
            className={`${classes.spacerMB2} ${classes.spacerMT2}`}
          >
            <Typography className={`${classes.RACPOPMsg} ${classes.bold}`}>
              {t('Suggested Addresses')}
            </Typography>
            <div className={classes.formCheck}>
              <RACRadio
                id="inlineRadio1"
                name="inlineRadioOptions"
                checked={defaultAddress == "GA" ? true : false}
                onClick={() => setDefaultAddress("GA")}
                value={"GA"}
              />
              <Typography
                className={`${classes.RACPOPMsg} ${classes.semiBold} ${classes.dispInlineFlex}`}
              >
                {validatedAddresses.suggestedAddress}
              </Typography>
            </div>
          </Grid>
        </Grid>
        <Grid
          className={`${classes.spacerMT4} ${classes.w100} ${classes.floatLeft}`}
        >
          <Grid className={classes.floatLeft}>
            <RACButton
              variant="outlined"
              color="primary"
              className={classes.foc}
              onClick={() => {
                setCanSuggestAddress(false)
                if (setCantProcessAddress) {
                  setCantProcessAddress()
                }
              }}
            >
              {t('Cancel')}
            </RACButton>
          </Grid>
          <Grid className={`${classes.floatRight}`}>
            <RACButton
              variant="contained"
              color="primary"
              disabled={pending}
              loading={pending}
              onClick={saveAddress}
            >
              {t('Continue')}
            </RACButton>
          </Grid>
        </Grid>
      </>
    );
  }
const disableSave = ()=> {
  if(pending)
    return true
  else{
    if((JSON.stringify(addressBackup)) == (JSON.stringify(address)))
      return true
    else if((address.street && address.exteriorNum && address.state && address.city && address.zipcode && address.suburb))
      return false
    else 
      return true
  }
}

  return (
    <>
      <Grid item md={6} sm={12} lg={6} xs={12} >
        <RACTextbox value={address.street} OnChange={updateAddress} id='street' disabled={disableInput.street || pending} inputlabel={t('Street')}  required={true} />
      </Grid>
      <Grid item md={6} sm={12} lg={6} xs={12}>
        <RACTextbox value={address.exteriorNum} OnChange={updateAddress} id='exteriorNum' disabled={disableInput.exteriorNum || pending} inputlabel={t('Exterior Number')} required={true} />
      </Grid>
      <Grid item md={6} sm={12} lg={6} xs={12}>
        <RACTextbox value={address.interiorNum} OnChange={updateAddress} id='interiorNum' disabled={disableInput.interiorNum || pending} inputlabel={t('Interior Number')} />
      </Grid>
      <Grid item md={6} sm={12} lg={6} xs={12}>
        <RACTextbox value={address.suburb ? address.suburb : ''} OnChange={updateAddress} id='suburb' disabled={disableInput.suburb || pending} inputlabel={t('Suburb')} required={true} />
      </Grid>
      <Grid item md={4} sm={12} lg={4} xs={12}>
        <RACTextbox value={address.zipcode} OnChange={updateAddress} id='zipcode' maxlength={5} Onblur={validateZipCode} disabled={disableInput.zipcode || pending} inputlabel={t('Zip Code')} required={true} type="number" />
      </Grid>
      <Grid item md={4} sm={12} lg={4} xs={12}>
        <RACTextbox value={address.city} OnChange={updateAddress} id='city' disabled={disableInput.city || pending} inputlabel={t('City')} required={true} />
      </Grid>
      <Grid item md={4} sm={12} lg={4} xs={12}>
        <RACSelect defaultValue={address.state} options={loadStates()} isDisabled={disableInput.state || pending} inputLabel={t('State')} required={true}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            updateAddress(e, 'state')
          }}
          {...(stateOpt.length == 1 &&
          {
            // eslint-disable-next-line sonarjs/no-duplicate-string
            errorMessage: t("Unable to fetch Data"),
          })}
        />
      </Grid>
      <Grid

        item md={12} sm={12} lg={12} xs={12}
        container
        justifyContent="flex-end"
        style={{ float: 'right' }}
      >
        <RACButton
          data-testid="addressSaveBtn"
          // style={{ right: '70px' }}
          variant="contained"
          size="large"
          color="primary"
          loading={pending}
          className={classes.saveButton}
          disabled={disableSave()}
          onClick={getSuggestion}
        >
          {t('Save')}
        </RACButton>
      </Grid>
      <RACModalCard
        isOpen={canSuggestAddress}
        maxWidth="sm"
        closeIcon={true}
        borderRadius="20px"
        onClose={() => {
          setCanSuggestAddress(false)
          if (setCantProcessAddress)
            setCantProcessAddress();
        }}
        // eslint-disable-next-line react/no-children-prop
        children={suggestAddressFn()}
        title={t("Validation Message")}
      />
      <RACModalCard
        isOpen={cantSuggestAddress}
        maxWidth="xs"
        borderRadius="20px"
        // eslint-disable-next-line react/no-children-prop
        children={suggestErrorInAddress()}
      />
    </>
  )
}

